import { AgencyService } from './../../../../api/agency.service';
import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';
import { LocaleAwareBaseComponent } from './../../../../seo/locale-aware-base.component';

@Component({
  selector: 'app-show-contact-form-modal-base',
  templateUrl: './show-contact-form-modal-base.component.html',
  styleUrls: ['./show-contact-form-modal-base.component.scss']
})

export class ShowContactFormModalBaseComponent extends LocaleAwareBaseComponent {
  constructor(
    public agencyService: AgencyService,
    public dialogRef: MatDialogRef<ShowContactFormModalBaseComponent>,
    @Inject(DOCUMENT) private document: any
  ) {
    super();

    dialogRef.afterClosed().subscribe(result => {
      this.document.body.classList.remove('no-scroll');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-contact-form-modal-base/show-contact-form-modal-base.component.ts